import {
  addressSchema,
  type AddressFormValues,
} from "@babackapp/return-widget-components/forms/address.form";
import { useFinancialSummary } from "@babackapp/return-widget-components/hooks/use-financial-summary";
import { useSetAddress } from "@babackapp/return-widget-components/hooks/use-set-address";
import { usePublicOrder } from "@babackapp/return-widget-components/queries/use-public-order";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useWidgetParams } from "./use-widget-params";

export function useAddressForm() {
  const navigate = useNavigate();
  const { orderId } = useWidgetParams();
  const { data: order } = usePublicOrder(orderId);
  const setAddress = useSetAddress(orderId);
  const financialSummary = useFinancialSummary(orderId, order ?? null);

  const defaultAddress = order?.shippingAddress;

  const form = useForm<AddressFormValues>({
    resolver: zodResolver(addressSchema),
    defaultValues: {
      first_name: defaultAddress?.first_name ?? "",
      last_name: defaultAddress?.last_name ?? "",
      address1: defaultAddress?.address1 ?? "",
      address2: defaultAddress?.address2 ?? "",
      city: defaultAddress?.city ?? "",
      zip: defaultAddress?.zip ?? "",
      country_code: defaultAddress?.country_code ?? "",
      email: defaultAddress?.email ?? "",
      phone: defaultAddress?.phone ?? "",
    },
  });

  const onSubmit = form.handleSubmit((values) => {
    setAddress(values as any);
    if (financialSummary.amountDue > 102) navigate("../checkout");
    else navigate("../complete");
  });

  return { form, onSubmit };
}
